import { getPanelParticipantsByPanelId } from "app/apis/panels"
import { useAppContext } from "app/contexts/AppContext"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const PanelMembers = ({ id }) => {
    const { t } = useTranslation();
    const [panelParticipants, setPanelParticipants] = useState([])
    const { selectedPanel } = useAppContext()
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!id) return;
        const fetchPanelParticipants = async () => {
            try {
                const response = await getPanelParticipantsByPanelId(id)
                setPanelParticipants(response.data)
            } catch (error) {
                console.error("Error has been occurred:", error)
                setError(error)
            } finally {
                setIsLoading(false)
            }
        }
        fetchPanelParticipants()
    }, [id, selectedPanel])

    if (error) return <span className="text-[18] text-red-500">{t("Error loading members")}</span>;
    if (isLoading) return <span className="text-[18] text-gray-500">{t("Loading...")}</span>;

    return (
        <span className="text-[18] text-red-500">
            {t("{{count}} Members", { count: panelParticipants?.length || 0 })}
        </span>
    )
}

export default PanelMembers